/**
 * The name plate over a tapped Pokémon: a `.win-light` plate that hides itself after
 * `--t-name-plate`. A new tap replaces it. The field scene says where it goes, in CSS pixels of
 * the field, every frame while it is up.
 */
import type { NamePlate } from '../field/FieldScene';
import { num } from './tokens';

/** The plate's bottom edge sits this far above the sprite's head, in CSS px. */
const GAP_CSS_PX = 4;

export function mountNamePlate(plate: HTMLElement): NamePlate {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return {
    show(name) {
      plate.textContent = name;
      plate.hidden = false;
      clearTimeout(timer);
      timer = setTimeout(() => (plate.hidden = true), num('t-name-plate'));
    },
    moveTo(x, y) {
      plate.style.transform = `translate(calc(${Math.round(x)}px - 50%), calc(${Math.round(y - GAP_CSS_PX)}px - 100%))`;
    },
    get open() {
      return !plate.hidden;
    },
  };
}
